import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appdate'
})
export class AppDatePipe implements PipeTransform {
  transform(value: any) {
    return value != undefined ? (new Date(value)).toLocaleString() : undefined;
  }
}
